import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnChanges, Output, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { ThemeInverse } from '@frontend/sports/common/ui/shared';
import { MediaQueryService } from '@frontend/vanilla/core';
import { isEqual } from 'lodash-es';
import { Observable, distinctUntilChanged, map } from 'rxjs';

import { EpcotConfigService } from '../../common/epcot-config.service';
import { MarketGroupItem } from '../multi-builder.model';

@Component({
    selector: 'ms-market-groups',
    templateUrl: 'market-groups.component.html',
    styleUrls: ['./market-groups.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MarketGroupsComponent implements OnChanges {
    @Input() groups: MarketGroupItem[] = [];
    @Output()
    selectedTab = new EventEmitter<MarketGroupItem>();

    scrollItems: MarketGroupItem[];

    readonly isEpcotEnabled: boolean;
    themeInverseIndicator: ThemeInverse;
    mediaQuery$: Observable<boolean>;
    isMobile: Signal<boolean | undefined>;

    @HostBinding('class') className = 'market-groups';

    constructor(
        private mediaQueryService: MediaQueryService,
        private epcotConfigService: EpcotConfigService,
        private cdr: ChangeDetectorRef,
    ) {
        this.isEpcotEnabled = this.epcotConfigService.isEnabled();
        this.mediaQuery$ = this.mediaQueryService.observe().pipe(
            map(() => this.mediaQueryService.isActive('lt-md')),
            distinctUntilChanged(),
        );
        this.isMobile = toSignal(this.mediaQuery$, { requireSync: true });
        this.themeInverseIndicator = this.isMobile()
            ? {
                  'mgm-4': { isInverse: true },
              }
            : {};
    }

    ngOnChanges(changes: ISimpleChanges<MarketGroupsComponent>): void {
        const shouldSetNewScrollItems = !isEqual(changes.groups?.previousValue, changes.groups?.currentValue);

        if (shouldSetNewScrollItems) {
            this.scrollItems = this.groups;
        }
    }

    eventSelected(marketGroupItem: MarketGroupItem): void {
        this.groups = this.groups.map((item) => ({
            ...item,
            active: item.id === marketGroupItem.id,
        }));
        this.cdr.markForCheck();
        this.selectedTab.emit(marketGroupItem);
    }
}
